import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import axios from "axios";
import { UserInfo } from "../../../context";
import SuperAdminLayout from "../../layout/SuperAdminLayout";
// import { UserInfo } from "../../../../context";
import { ShopOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import AddStoreAdmin from "./AddStoreAdmin";
import DisplayMerchantsConnection from "./DisplayMerchantsConnection";
// import UpdateSubscription from "./UpdateSubscription";
// import UpdateDuration from "./UpdateDuration";

const StoreAdmin = () => {
  const [adminList, setAdminList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storeAdminMerchants, setStoreAdminMerchants] = useState(false);

  const columns = [
    {
      title: "Name",
      render: (text, record) => (
        <p>
          {text.firstname} {text.lastname}
        </p>
      ),
    },
    {
      title: "Contact #",
      render: (text, record) => <p>{text.contact_no}</p>,
    },
    {
      title: "Address",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
          }}
        >
          {text.street !== null ? `${text.street}, ` : ""}
          {text.barangay !== null ? `${text.barangay}, ` : ""}
          {text.city !== null ? `${text.city}, ` : ""}
          {text.province !== null ? `${text.province}` : ""}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Branches">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setStoreAdminMerchants(true);
              }}
              icon={<ShopOutlined />}
              //   style={{ marginRight: 10 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getStoreAdminList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/admin/store-admin-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setAdminList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getStoreAdminList();
  }, [getStoreAdminList]);

  const searchable = adminList.data.filter((data) => {
    return (
      data.firstname.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.lastname.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <SuperAdminLayout>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search admin"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            // onClick={() => setSelectedTab("form")}
            onClick={() => setOpenDrawer(true)}
            // disabled={productList.data.length >= parseInt(limit)}
          >
            Add Admin
          </Button>
        </div>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          //   dataSource={adminList.data.length > 0 ? adminList.data : []}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />

        {/* {updateDuration && (
        <UpdateDuration
          open={updateDuration}
          close={() => setUpdateDuration(false)}
          getStoreAdminList={() => getStoreAdminList()}
          selectedData={selectedData}
        />
      )}

      {updateSubscription && (
        <UpdateSubscription
          open={updateSubscription}
          close={() => setUpdateSubscription(false)}
          getStoreAdminList={() => getStoreAdminList()}
          selectedData={selectedData}
        />
      )} */}

        {openDrawer && (
          <AddStoreAdmin
            open={openDrawer}
            close={() => setOpenDrawer(false)}
            setLoading={setLoading}
            rerun={() => getStoreAdminList()}
          />
        )}

        {storeAdminMerchants && (
          <DisplayMerchantsConnection
            open={storeAdminMerchants}
            close={() => setStoreAdminMerchants(false)}
            // setLoading={setLoading}
            // rerun={() => getStoreAdminList()}
            selectedData={selectedData}
          />
        )}
      </div>
    </SuperAdminLayout>
  );
};

export default StoreAdmin;
